import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationsFetchFailedAction = {
	type: 'ORGANIZATIONS_FETCH_FAILED';
	payload: ExtractedMessages;
	/** The HTTP status of the failed request, `null` when the failure never reached the server (e.g. a network error). */
	status: number | null;
};

export default (payload: ExtractedMessages, status: number | null): OrganizationsFetchFailedAction => ({
	type: 'ORGANIZATIONS_FETCH_FAILED',
	payload,
	status,
});
